import { FETCH_INFORMATIONS, FETCH_INFORMATIONS_SUCCESS, SET_TRIP_STATUS, CLEAR_INFORMATIONS } from '../actions/trip';
import { Action as BookingAction } from '../actions/booking';
import { Trip, TripStatus } from '../model';

import type { State } from './index';

export interface TripState {
  start: Trip;
  end: Trip;
}

interface Action {
  type: string;
  prefix: 'start' | 'end';
  results: any;
  status?: TripStatus;
}

const initialTrip: Trip = {
  results: [],
  isFetchingInformations: false,
  status: TripStatus.None,
};

const initialState: TripState = {
  start: { ...initialTrip },
  end: { ...initialTrip },
};

export default (state: TripState = initialState, action: Action) => {
  const { prefix } = action;
  switch (action.type) {
    case FETCH_INFORMATIONS:
      return {
        ...state,
        [prefix]: { ...state[prefix], status: TripStatus.None, isFetchingInformations: true },
      };
    case FETCH_INFORMATIONS_SUCCESS:
      return {
        ...state,
        [prefix]: { ...state[prefix], isFetchingInformations: false, results: action.results },
      };
    case SET_TRIP_STATUS:
      return {
        ...state,
        [prefix]: {
          ...state[prefix],
          status: action.status,
          results: action.status === TripStatus.Unknown ? [] : state[prefix].results,
        },
      };
    case CLEAR_INFORMATIONS:
      return {
        ...state,
        [prefix]: { ...initialTrip },
      };
    case BookingAction.Type.INVALID_ARRIVAL_TRIP:
      return {
        ...state,
        end: { ...state.end, status: TripStatus.None },
      };
    default:
      return state;
  }
};

export const getEndTrip = (state: State) => state.trip.end;
